// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let NotesV2Api = class NotesV2Api {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @summary Get list of Tasks within a Program, with optional filters
     * @param start 0-based index of starting position
     * @param pageSize How many records to include at a time
     * @param onlyIncludeIncomplete Whether or not to only include incomplete tasks
     * @param isAssigned Optional filter to only include assigned or unassigned items
     * @param assignedUserId Optional User ID to filter to; will match any (including unassigned) if null or not provided
     * @param accountId Optional Account ID to filter to; will match any if null or not provided
     * @param caseId Optional Case ID; will match any if null or not provided
     * @param partyId Optional Party ID; will match any if null or not provided
     * @param typeId Optional Type ID; will match any if null or not provided
     * @param x_program_id The program id from the list of allowed program ids
     */
    async getByProgramByProgramId(start, pageSize, onlyIncludeIncomplete, isAssigned, assignedUserId, accountId, caseId, partyId, typeId, x_program_id) {
        const _url_ = '/notes/v2/Task';
        let _params_ = {};
        let _headers_ = {};
        if (start !== undefined) {
            _params_['start'] = Serializer.serialize(start, "number");
        }
        if (pageSize !== undefined) {
            _params_['pageSize'] = Serializer.serialize(pageSize, "number");
        }
        if (onlyIncludeIncomplete !== undefined) {
            _params_['onlyIncludeIncomplete'] = Serializer.serialize(onlyIncludeIncomplete, "boolean");
        }
        if (isAssigned !== undefined) {
            _params_['isAssigned'] = Serializer.serialize(isAssigned, "boolean");
        }
        if (assignedUserId !== undefined) {
            _params_['assignedUserId'] = Serializer.serialize(assignedUserId, "number");
        }
        if (accountId !== undefined) {
            _params_['accountId'] = Serializer.serialize(accountId, "number");
        }
        if (caseId !== undefined) {
            _params_['caseId'] = Serializer.serialize(caseId, "number");
        }
        if (partyId !== undefined) {
            _params_['partyId'] = Serializer.serialize(partyId, "number");
        }
        if (typeId !== undefined) {
            _params_['typeId'] = Serializer.serialize(typeId, "number");
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "number");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "NoteTaskModels");
        }
        return response;
    }
    /**
     *
     * @summary Get a list of Note Types by Program
     * @param noteTypeCategory Note Type Category
     * @param x_program_id The program id from the list of allowed program ids
     */
    async programNoteTypeGetByProgramId(noteTypeCategory, x_program_id) {
        const _url_ = '/notes/v2/ProgramNoteType/{noteTypeCategory}'
            .replace('{' + 'noteTypeCategory' + '}', encodeURIComponent(String(noteTypeCategory)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'noteTypeCategory' is not null or undefined
        if (noteTypeCategory === null || noteTypeCategory === undefined) {
            throw new Error('Required parameter noteTypeCategory was null or undefined when calling programNoteTypeGetByProgramId.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "number");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "NoteTypeModels");
        }
        return response;
    }
    /**
     *
     * @summary Get an existing Task by Program and Task identifiers.
     * @param taskId The task identifier.
     * @param x_program_id The program id from the list of allowed program ids
     */
    async taskGetByProgramId(taskId, x_program_id) {
        const _url_ = '/notes/v2/Task/{taskId}'
            .replace('{' + 'taskId' + '}', encodeURIComponent(String(taskId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'taskId' is not null or undefined
        if (taskId === null || taskId === undefined) {
            throw new Error('Required parameter taskId was null or undefined when calling taskGetByProgramId.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "number");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "NoteTaskModelResponse");
        }
        return response;
    }
};
NotesV2Api = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], NotesV2Api);
export { NotesV2Api };
//# sourceMappingURL=notesV2Api.js.map